var addsCase = [],
    allCostCreate = 0,
    battleCreateCountUsers = 2,
    battleCreatePrivacy = 'public';

$(function () {

    $('body').on('click', '.create-el__remove', function(){
        let $this = $(this),
            nowId = $this.closest('.create-el').find('input[name=caseid]').val();

        for(let i = 0; i < addsCase.length; i++){
            if(Number(addsCase[i].caseId) === Number(nowId)) {

                allCostCreate = allCostCreate - (addsCase[i].cost * addsCase[i].count);
                updateAllCost();
                addsCase.splice(i,1);
            }
        }

        $('.create-head__count').html('<span>'+addsCase.length+'</span>/'+addsCase.length);
        $this.closest('.create-el').remove();

        $('.add-modal__el[data-id='+nowId+']').removeClass('active').find('.add-modal__add .number').html(1);

        if(addsCase.length === 0){
            $('.create-footer__create').addClass('disable');
        }

    });

    $('.create-footer__btn').on('click', function(e){
        e.preventDefault();

        let $this = $(this);
        $this.closest('.create-footer__btns').find('.create-footer__btn').removeClass('active');
        $this.addClass('active');

        if($this.data('name') === 'players'){
            battleCreateCountUsers = $this.data('val');
        }else if($this.data('name') === 'privacy') {
            battleCreatePrivacy = $this.data('val');

            console.log($this.data('val'));

            if($this.data('val') === 'public'){
                $('.coliseum-subhead__copy').addClass('hide');
            }else{
                $('.coliseum-subhead__copy').removeClass('hide');
            }
        }
    });

    $('.create-footer__create').on('click', function(e){
        e.preventDefault();

        let $this = $(this);

        if(!$this.hasClass('disable') && addsCase.length > 0){

        }
    });
});


